/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../id_pair';
import '../../common/currency';
import '../creator_details';
import '../date';
import './tender';
import '../../common/fee';
import './cash_drawer_details';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "bills": {
            "nested": {
              "Refund": {
                "fields": {
                  "refundIdPair": {
                    "type": ".squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.client.bills.Refund.State",
                    "id": 2,
                    "rule": "optional"
                  },
                  "writeOnlyLinkedBillServerToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "writeOnlyLinkedTenderServerToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "writeOnlyAmount": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "writeOnlyCreatorDetails": {
                    "type": ".squareup.client.CreatorDetails",
                    "id": 7,
                    "rule": "optional"
                  },
                  "reasonOption": {
                    "type": ".squareup.client.bills.Refund.ReasonOption",
                    "id": 15,
                    "rule": "optional",
                    "options": {
                      "default": "UNKNOWN_REASON"
                    }
                  },
                  "reason": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "checkoutRefundId": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "readOnlyLocalizedErrorTitle": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "readOnlyLocalizedErrorDescription": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "writeOnlyRequestedAt": {
                    "type": ".squareup.client.ISO8601Date",
                    "id": 11,
                    "rule": "optional"
                  },
                  "readOnlyRefundedAt": {
                    "type": ".squareup.client.ISO8601Date",
                    "id": 12,
                    "rule": "optional"
                  },
                  "readOnlyLinkedTender": {
                    "type": ".squareup.client.bills.Tender",
                    "id": 13,
                    "rule": "optional"
                  },
                  "readOnlyDestination": {
                    "type": ".squareup.client.bills.Refund.Destination",
                    "id": 14,
                    "rule": "optional"
                  },
                  "feeRefundPolicy": {
                    "type": ".squareup.common.RefundPolicy",
                    "id": 17,
                    "rule": "optional"
                  },
                  "cashDrawerDetails": {
                    "type": ".squareup.client.bills.CashDrawerDetails",
                    "id": 18,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "State": {
                    "values": {
                      "UNKNOWN_STATE_DO_NOT_USE": 0,
                      "NEW": 1,
                      "PENDING": 2,
                      "SUCCESS": 3,
                      "FAILED": 4
                    }
                  },
                  "ReasonOption": {
                    "values": {
                      "UNKNOWN_REASON": 0,
                      "RETURNED_GOODS": 1,
                      "ACCIDENTAL_CHARGE": 2,
                      "CANCELED_ORDER": 3,
                      "OTHER_REASON": 4,
                      "FRAUDULENT_CHARGE": 5
                    }
                  },
                  "Destination": {
                    "fields": {
                      "giftCardDestination": {
                        "type": ".squareup.client.bills.Refund.Destination.GiftCardDestination",
                        "id": 1
                      },
                      "tenderDestination": {
                        "type": ".squareup.client.bills.Tender",
                        "id": 2
                      }
                    },
                    "nested": {
                      "GiftCardDestination": {
                        "fields": {
                          "giftCardToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "giftCardPanSuffix": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "type": {
                            "type": ".squareup.client.bills.Refund.Destination.GiftCardDestination.Type",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": "PHYSICAL"
                            }
                          },
                          "giftCardBalance": {
                            "type": ".squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": ".squareup.client.ISO8601Date",
                            "id": 6,
                            "rule": "optional"
                          },
                          "totalMoney": {
                            "type": ".squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "creatorDetails": {
                            "type": ".squareup.client.CreatorDetails",
                            "id": 8,
                            "rule": "optional"
                          },
                          "readOnlyReceiptNumber": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "cardTender": {
                            "type": ".squareup.client.bills.CardTender",
                            "id": 10,
                            "rule": "optional"
                          },
                          "tenderIdPair": {
                            "type": ".squareup.client.IdPair",
                            "id": 11,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Type": {
                            "values": {
                              "TYPE_UNKNOWN": 0,
                              "PHYSICAL": 1,
                              "DIGITAL": 2
                            }
                          }
                        }
                      },
                      "details": {
                        "oneof": ["giftCardDestination", "tenderDestination"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Refund && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Refund?.nested?.State && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Refund?.nested?.ReasonOption && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Refund?.nested?.Destination && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Refund?.nested?.Destination?.nested?.GiftCardDestination && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Refund?.nested?.Destination?.nested?.GiftCardDestination?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Refund @ squareup/client/bills/refund_v3.proto at 18:1
 */
export const Refund = $root.lookupType('squareup.client.bills.Refund');
fixType(Refund, {
  refundIdPair: {
    required: true
  },
  state: {
    required: true
  },
  writeOnlyAmount: {
    required: true
  },
  reason: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Refund);
/**
 * SOURCE State @ squareup/client/bills/refund_v3.proto at 28:3
 */
Refund.State = $root.lookupEnum('squareup.client.bills.Refund.State').values;
/**
 * SOURCE ReasonOption @ squareup/client/bills/refund_v3.proto at 63:3
 */
Refund.ReasonOption = $root.lookupEnum('squareup.client.bills.Refund.ReasonOption').values;
/**
 * Identifies the destination for the refunded value, if different from the
 * linked (i.e. source) tender. Only set by the server; requests for gift card
 * refunds with a destination that is not one of the source tenders should be
 * constructed in a RefundToGiftCardRequest.
 *
 * SOURCE Destination @ squareup/client/bills/refund_v3.proto at 127:3
 */
Refund.Destination = $root.lookupType('squareup.client.bills.Refund.Destination');
fixType(Refund.Destination);
Builder.createAndAttachToType(Refund.Destination);
/**
 * Identifies a gift card onto which value will be refunded. This message's fields will always
 * be populated for successful refunds.
 *
 * SOURCE GiftCardDestination @ squareup/client/bills/refund_v3.proto at 134:5
 */
Refund.Destination.GiftCardDestination = $root.lookupType('squareup.client.bills.Refund.Destination.GiftCardDestination');
fixType(Refund.Destination.GiftCardDestination);
Builder.createAndAttachToType(Refund.Destination.GiftCardDestination);
/**
 * SOURCE Type @ squareup/client/bills/refund_v3.proto at 140:7
 */
Refund.Destination.GiftCardDestination.Type = $root.lookupEnum('squareup.client.bills.Refund.Destination.GiftCardDestination.Type').values;